import axios from "axios";
import { IGoogleSheetResponse } from "./type";

const ASGARD_GOOGLE_SHEET_URL = `https://script.google.com/macros/s/AKfycbxbvee9x8Z7g8ZGP7IjNNLxPJ-F3bgeCs2f49cqhbs86K4xJB-TEt3fYOIrPxNLxOEuYQ/exec`;

export const getAllGoogleSheetRecord = async () => {
  const response = await axios.get(`${ASGARD_GOOGLE_SHEET_URL}?type=getAll`);

  return response.data;
};

export const createGoogleSheetRecord = async (
  name: string,
  email: string,
  phone: string,
  vehicle_model: string,
  vehicle_production_year: string
) => {
  const response = await axios.get<IGoogleSheetResponse>(
    `${ASGARD_GOOGLE_SHEET_URL}?type=create&name=${name}&email=${email}&phone=${phone}&vehicle_model=${vehicle_model}&vehicle_production_year=${vehicle_production_year}`
  );

  return response.data;
};
